<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  position="center"
  [appendTo]="'body'"
  [style]="{ width: '480px', 'max-width': '95vw' }"
  [contentStyle]="{ 'overflow-y': 'auto', 'max-height': '85vh', padding: '0' }"
  styleClass="loja-fechada-dialog cardapio-info-dialog"
  maskStyleClass="cardapio-info-mask"
  (onHide)="onHide()"
  (onShow)="onShow()">

  <!-- Header com icone -->
  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i class="pi pi-clock dialog-header-icon"></i>
      <span class="dialog-header-title">{{ 'cardapio_digital.loja_fechada.titulo' | translate }}</span>
    </div>
  </ng-template>

  <div class="dialog-info-content" *ngIf="estabelecimento">

    <!-- Status badge (acima do nome, igual ao sidebar) + data e hora atual ao lado -->
    <div class="status-row">
      <div class="status-badge fechado">
        <span class="status-dot"></span>
        <span>{{ 'cardapio_digital.fechado' | translate }}</span>
      </div>
      <span class="hora-atual">
        <i class="pi pi-calendar"></i>
        {{ dataAtual }} - {{ horaAtual }}
      </span>
    </div>

    <!-- Nome da loja + Logo (nome esquerda, logo direita, igual ao sidebar) -->
    <div class="store-header">
      <div class="store-info">
        <h2 class="store-name">{{ estabelecimento.nome }}</h2>
        <!-- Redes sociais inline (igual ao sidebar) -->
        <div class="social-rating-row">
          <div class="social-icons">
            <a *ngIf="estabelecimento.telefoneWhatsapp"
               [href]="getWhatsappLink()"
               target="_blank" rel="noopener noreferrer"
               class="social-icon social-icon--whatsapp"
               title="WhatsApp">
              <i class="pi pi-whatsapp"></i>
            </a>
            <a *ngIf="estabelecimento.perfilInstagram"
               [href]="getInstagramLink()"
               target="_blank" rel="noopener noreferrer"
               class="social-icon social-icon--instagram"
               title="Instagram">
              <i class="pi pi-instagram"></i>
            </a>
            <a *ngIf="estabelecimento.perfilFacebook"
               [href]="getFacebookLink()"
               target="_blank" rel="noopener noreferrer"
               class="social-icon social-icon--facebook"
               title="Facebook">
              <i class="pi pi-facebook"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="store-logo-wrapper">
        <img *ngIf="estabelecimento.logo"
             [src]="estabelecimento.logo"
             [alt]="estabelecimento.nome"
             class="store-logo-img">
        <div *ngIf="!estabelecimento.logo" class="store-logo-placeholder">
          <i class="pi pi-shop"></i>
        </div>
      </div>
    </div>

    <!-- Separador -->
    <hr class="section-divider">

    <!-- Endereco (layout simples, igual ao sidebar) -->
    <div class="section" *ngIf="estabelecimento.endereco">
      <h3 class="section-title">{{ 'cardapio_digital.sidebar.endereco_titulo' | translate }}</h3>
      <div class="endereco-row">
        <i class="pi pi-map-marker endereco-icon"></i>
        <span class="endereco-text">{{ estabelecimento.endereco }}</span>
      </div>
    </div>

    <!-- Tipos de servico -->
    <div class="section">
      <h3 class="section-title">{{ 'cardapio_digital.sidebar.tipos_servico_titulo' | translate }}</h3>
      <div class="tipos-servico-list">
        <div class="tipo-servico-card">
          <div class="tipo-servico-info">
            <div class="tipo-servico-icon">
              <i class="pi pi-car"></i>
            </div>
            <span>{{ 'cardapio_digital.sidebar.entrega' | translate }}</span>
          </div>
          <i class="pi pi-check tipo-servico-check"></i>
        </div>
        <div class="tipo-servico-card">
          <div class="tipo-servico-info">
            <div class="tipo-servico-icon">
              <i class="pi pi-shopping-bag"></i>
            </div>
            <span>{{ 'cardapio_digital.sidebar.retirada' | translate }}</span>
          </div>
          <i class="pi pi-check tipo-servico-check"></i>
        </div>
      </div>
    </div>

    <!-- Separador -->
    <hr class="section-divider">

    <!-- Horarios de atendimento -->
    <div class="section" *ngIf="horarios.length > 0">
      <h3 class="section-title">{{ 'cardapio_digital.sidebar.horarios_titulo' | translate }}</h3>
      <div class="horarios-list">
        <div class="horario-item" *ngFor="let h of horarios" [class.horario-atual]="h.atual" [class.horario-fechado]="h.fechado">
          <span class="horario-dia">{{ h.dia }}</span>
          <div class="horario-valor">
            <i class="pi pi-clock horario-clock"></i>
            <span [class.fechado-text]="h.fechado">{{ h.horario }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Botao compartilhar (no lugar do Meus Pedidos do sidebar) -->
    <div class="section pedidos-section">
      <hr class="section-divider">
      <button class="pedidos-dialog-btn" (click)="compartilhar()">
        <i class="pi pi-share-alt"></i>
        <span>{{ 'cardapio_digital.loja_fechada.compartilhar' | translate }}</span>
      </button>
    </div>

  </div>
</p-dialog>

<p-toast position="top-center"></p-toast>
